import React, { Component } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
class ColumnChart extends Component {
  render() {
    const items = this.props.datos;
    const chartOptions = {
      chart: {
        type: "column"
      },
      colors: ['#008BD2'],
      title: {
        text: this.props.title || "Bar Chart Title"
      },
      xAxis: {
        categories: this.props.category || [],
        crosshair: true,
        labels: {
          rotation: -45,
          style: {
            fontSize: "13px",
            fontFamily: "Verdana, sans-serif"
          }
        }
      },
      yAxis: {
        title: {
          text: this.props.titley || "Cantidad"
        }
      },
      tooltip: {
        headerFormat:
          'Denuncias registradas en <span  style="color:{point.color}">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y}</b></td></tr>',
        footerFormat: "</table>",
        shared: true,
        useHTML: true
      },
      series: items,
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
          dataLabels: {
            enabled: true
          }
        }
      },
      credits: {
        enabled: false
      },
      lang: {
        noData: "No hay datos para mostrar" //the text to be displayed
      },
      noData: {
        position: {
          x: 0,
          y: 0,
          align: "center",
          verticalAlign: "middle"
        }
      },
      exporting: {
        buttons: {
          contextButton: {
            menuItems: [{
              text: "Imprimir",
              textKey: 'printChart',
              onclick: function () {
                this.print();
              }
            }, {
              text: "Descargar como PNG",
              textKey: 'downloadPNG',
              onclick: function () {
                this.exportChart();
              }
            }, {
              text: "Descargar como JPEG",
              textKey: 'downloadJPEG',
              onclick: function () {
                this.exportChart({
                  type: 'image/jpeg'
                });
              }
            }, {
              text: "Descargar como PDF",
              textKey: 'downloadPDF',
              onclick: function () {
                this.exportChart({
                  type: 'application/pdf'
                });
              }
            }]
          }
        }
      }
    };
    return (
      <div>
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      </div>
    );
  }
}

export default ColumnChart;
